(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8205],{

/***/ 1713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/search",
      function () {
        return __webpack_require__(40240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./ui/components/Breadcrumb.tsx + 1 modules
var Breadcrumb = __webpack_require__(37404);
// EXTERNAL MODULE: ./ui/components/ProductList.tsx + 2 modules
var ProductList = __webpack_require__(79072);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./ui/components/ProductListItem.tsx + 6 modules
var ProductListItem = __webpack_require__(4291);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/components/LoadMore.tsx
var LoadMore = __webpack_require__(79892);
// EXTERNAL MODULE: ./ui/components/NoSearchResults.tsx + 2 modules
var NoSearchResults = __webpack_require__(20769);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/elements/ScrollToTopButton.tsx
var ScrollToTopButton = __webpack_require__(39454);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(19989);
// EXTERNAL MODULE: ../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(70463);
// EXTERNAL MODULE: ../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(25380);
// EXTERNAL MODULE: ./gql/fragments/product.ts
var product = __webpack_require__(19404);
// EXTERNAL MODULE: ./gql/fragments/products.ts
var products = __webpack_require__(46709);
// EXTERNAL MODULE: ./gql/queries/products.ts
var queries_products = __webpack_require__(78217);
;// CONCATENATED MODULE: ./gql/queries/search.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query TrendingSearchTerms {\n    trendingSearchTerms {\n      searchTerm\n      rank\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query SearchRecommendedProducts {\n    searchFlyoutRecommendedProducts {\n      __typename\n      id\n      variantProduct {\n        id\n        masterId\n        colorValue\n        name\n        header\n        subHeader\n        productPrice {\n          price\n          salePrice\n        }\n        images {\n          alt\n          href\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ProductSearch(\n    $q: String\n    $sort: String\n    $filters: [FilterInputOption!]!\n    $expansions: [ProductSearchExpansion!]\n    $includeSearchMetadata: Boolean = true\n    $offset: Int!\n    $limit: Int!\n  ) {\n    search(\n      input: {\n        q: $q\n        sort: $sort\n        filters: $filters\n        limit: $limit\n        offset: $offset\n        expansions: $expansions\n        includeSearchMetadata: $includeSearchMetadata\n      }\n    ) {\n      __typename\n      ...PaginatedOutputNodesFragment\n      ...PaginatedOutputMetadataFragment @include(if: $includeSearchMetadata)\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var TRENDING_SEARCH_TERMS = (0,urql_core/* gql */.Ps)(_templateObject());
var SEARCH_RECOMMENDED_PRODUCTS = (0,urql_core/* gql */.Ps)(_templateObject1());
var PRODUCT_SEARCH_QUERY = (0,urql_core/* gql */.Ps)(_templateObject2(), products/* PAGINATED_OUTPUT_NODES_FRAGMENT */.L, products/* PAGINATED_OUTPUT_METADATA_FRAGMENT */.q, product/* MANDATORY_MASTER_FIELDS */.YP, product/* MANDATORY_VARIANT_FIELDS */.EN);
var useProductSearchQuery = function(options) {
    return (0,urql_es/* useQuery */.aM)({
        query: PRODUCT_SEARCH_QUERY,
        pause: options.pause,
        variables: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,queries_products/* commonQueryVariables */.J)(options)), {
            includeSearchMetadata: options.includeMetadata
        })
    });
};

// EXTERNAL MODULE: ./utils/products.ts
var utils_products = __webpack_require__(1032);
// EXTERNAL MODULE: ./ui/components/ProductListFilterProvider.tsx
var ProductListFilterProvider = __webpack_require__(64648);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./hooks/useScreenSize.ts
var useScreenSize = __webpack_require__(32629);
// EXTERNAL MODULE: ./utils/productFilters.ts
var productFilters = __webpack_require__(49341);
;// CONCATENATED MODULE: ./pages/[country]/[language]/search.tsx
























var PaginatedPage = function(param) {
    var offset = param.offset, isLast = param.isLast, totalCount = param.totalCount, productSearchResult = param.productSearchResult, productsRef = param.productsRef, allProductsRef = param.allProductsRef, handleIntersection = param.handleIntersection, setListProducts = param.setListProducts;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,_sliced_to_array/* default */.Z)(useProductSearchQuery({
        pause: productSearchResult !== null,
        router: router,
        offset: offset,
        includeMetadata: false
    }), 1), productSearchPaginated = ref1[0];
    // Determine whether to use the supplied queries (for the first page or results) or the
    // queries executed in this component
    var query = productSearchResult !== null && productSearchResult !== void 0 ? productSearchResult : productSearchPaginated;
    var products = react.useMemo(function() {
        var ref;
        return ((ref = query.data) === null || ref === void 0 ? void 0 : ref.search.nodes.filter(function(param) {
            var masterProduct = param.masterProduct;
            return masterProduct !== null;
        })) || [];
    }, [
        (ref = query.data) === null || ref === void 0 ? void 0 : ref.search.nodes
    ]);
    var prevProductsRef = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        var newProducts = products.filter(function(product) {
            return !prevProductsRef.current.some(function(p) {
                var ref, ref1;
                return (p === null || p === void 0 ? void 0 : (ref = p.variantProduct) === null || ref === void 0 ? void 0 : ref.id) === (product === null || product === void 0 ? void 0 : (ref1 = product.variantProduct) === null || ref1 === void 0 ? void 0 : ref1.id);
            });
        });
        if (newProducts.length > 0) {
            setListProducts(function(prevProducts) {
                var updatedProducts = (0,_to_consumable_array/* default */.Z)(prevProducts).concat((0,_to_consumable_array/* default */.Z)(newProducts));
                prevProductsRef.current = updatedProducts;
                return updatedProducts;
            });
        }
    }, [
        products,
        setListProducts
    ]);
    (0,react.useEffect)(function() {
        var options = {
            root: null,
            rootMargin: "1px",
            threshold: 0.5
        };
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var productId = entry.target.getAttribute("data-product-id");
                    var dataTestId = entry.target.getAttribute("data-test-id");
                    handleIntersection(productId || dataTestId);
                }
            });
        }, options);
        document.querySelectorAll('[data-test-id="product-list-item"]').forEach(function(item) {
            return observer.observe(item);
        });
        var styliticsPromoTile = document.querySelector('[data-test-id="positioned-promo-tile"]');
        if (styliticsPromoTile) observer.observe(styliticsPromoTile);
        return function() {
            observer.disconnect();
        };
    }, [
        handleIntersection,
        productsRef,
        allProductsRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !query.fetching && products.map(function(p, i) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductListItem/* ProductListItem */.A, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                    position: offset + i + 1,
                    search: query === null || query === void 0 ? void 0 : (ref = query.operation) === null || ref === void 0 ? void 0 : ref.variables.q
                }), p.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore/* LoadMore */.f, {
                fetching: query.fetching,
                isLastPageCurrentlyDisplayed: isLast,
                totalCount: totalCount
            })
        ]
    });
};
var ProductSearch = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,useSiteConfig/* useSiteConfig */.N)(), localizeUrlPath = ref3.localizeUrlPath, isLocalizedFeatureFlagEnabled = ref3.isLocalizedFeatureFlagEnabled;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var searchTerm = router.query.q || "";
    var intersectedProductsRef = (0,react.useRef)([]);
    var pageviewEventHasFired = (0,usePageEventsContext/* usePageEventsContext */.qN)().pageviewEventHasFired;
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var intersectAllProductsRef = (0,react.useRef)([]);
    var screenSize = (0,useScreenSize/* useScreenSize */.e)();
    var ref4 = (0,react.useState)([]), listProducts = ref4[0], setListProducts = ref4[1];
    var handleIntersection = (0,react.useCallback)(function(productId) {
        (0,analytics/* handleIntersectionPLP */.RQ)({
            productId: productId,
            intersectedProductsRef: intersectedProductsRef,
            intersectAllProductsRef: intersectAllProductsRef,
            listProducts: listProducts,
            screenSize: screenSize,
            currency: currency,
            offset: offset,
            pageviewEventHasFired: pageviewEventHasFired,
            searchTerm: searchTerm
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        listProducts,
        screenSize,
        pageviewEventHasFired
    ]);
    var routeShards = router.asPath.split("?");
    var queryString = (routeShards === null || routeShards === void 0 ? void 0 : routeShards[1]) || "";
    var newQueryParams = (0,react.useMemo)(function() {
        return new URLSearchParams(queryString);
    }, [
        queryString
    ]);
    var queryParams = (0,react.useMemo)(function() {
        return Array.from(newQueryParams).reduce(function(result, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
            result[key] = value;
            return result;
        }, {});
    }, [
        newQueryParams
    ]);
    var validFilters = (0,productFilters/* decodeFilters */.id)(queryParams);
    var hasFilterSelected = Boolean(Object.keys(validFilters).length);
    var ref5 = (0,_sliced_to_array/* default */.Z)(useProductSearchQuery({
        pause: !searchTerm,
        router: router,
        offset: 0,
        includeMetadata: true
    }), 1), productSearchResult = ref5[0];
    var path = react.useMemo(function() {
        return [
            {
                label: "home",
                url: ""
            },
            {
                label: searchTerm,
                url: ""
            }, 
        ];
    }, [
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        // This console is for QAs to test the feature flag sytem
        if (searchTerm === "feature_flag_qa_test" && isLocalizedFeatureFlagEnabled("QA_TEST_FLAG")) {
            // eslint-disable-next-line no-console
            console.log("Hi, QA \uD83D\uDC4B!");
        }
    }, [
        isLocalizedFeatureFlagEnabled,
        searchTerm
    ]);
    (0,react.useEffect)(function() {
        if (!searchTerm) {
            // No search term was supplied so redirect to home
            router.replace(localizeUrlPath("/"));
        }
    }, [
        router,
        searchTerm,
        localizeUrlPath
    ]);
    var searchResults = (ref = productSearchResult.data) === null || ref === void 0 ? void 0 : ref.search;
    var totalCount = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.totalCount) || 0;
    var queryOffset = Number(router.query.offset) || 0;
    var offset = totalCount && queryOffset >= totalCount ? totalCount - utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur : queryOffset;
    (0,react.useEffect)(function() {
        if (!productSearchResult.fetching) (0,analytics/* searchAnalyticsEvent */.dr)("".concat(totalCount));
    }, [
        totalCount,
        productSearchResult.fetching
    ]);
    if (!searchTerm) return null;
    var list = new Array(queryOffset / utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur + 1).fill(1);
    var isStale = (productSearchResult === null || productSearchResult === void 0 ? void 0 : (ref1 = productSearchResult.operation) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variables) === null || ref2 === void 0 ? void 0 : ref2.q) !== searchTerm;
    var noResults = !productSearchResult.fetching && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.nodes.length) === 0;
    var showLoadingIndicator = isStale || offset !== 0 && productSearchResult.fetching && !productSearchResult.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: "".concat(t("searchResult"), ": ").concat(searchTerm)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, productSearchResult), {
                    fetching: showLoadingIndicator
                }),
                bloomreachData: {
                    search_term: searchTerm
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListFilterProvider/* ProductListFilterProvider */.w, {
                        noResults: noResults,
                        filteringOptions: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.filteringOptions) || [],
                        sortingOptions: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.sortingOptions) || [],
                        defaultSortOption: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.selectedSort) || "",
                        isFetching: productSearchResult.fetching,
                        totalCount: totalCount,
                        search: router.query.q,
                        children: noResults && !hasFilterSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSearchResults/* NoAnalyticsNoSearchResults */.dq, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* Breadcrumb */.a, {
                                    path: path
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* ProductList */.c, {
                                    noResults: noResults,
                                    filteringOptions: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.filteringOptions) || [],
                                    sortingOptions: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.sortingOptions) || [],
                                    defaultSortOption: (searchResults === null || searchResults === void 0 ? void 0 : searchResults.selectedSort) || "",
                                    isFetching: productSearchResult.fetching,
                                    totalCount: totalCount,
                                    search: router.query.q,
                                    children: list.map(function(_, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginatedPage, {
                                            isFirst: i === 0,
                                            isLast: i === list.length - 1,
                                            offset: i * utils_products/* MAX_PRODUCT_PAGE_SIZE */.ur,
                                            totalCount: totalCount,
                                            productSearchResult: i === 0 ? productSearchResult : null,
                                            productsRef: intersectedProductsRef,
                                            allProductsRef: intersectAllProductsRef,
                                            handleIntersection: handleIntersection,
                                            setListProducts: setListProducts
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollToTopButton/* ScrollToTopButton */.U, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var search = (ProductSearch);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,2779,9294,2042,6740,769,7002,9774,2888,179], function() { return __webpack_exec__(1713); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);